
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/campground-rental/[location]/[slug]/photos",
      function () {
        return require("private-next-pages/campground-rental/[location]/[slug]/photos.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/campground-rental/[location]/[slug]/photos"])
      });
    }
  